import { useEffect, useState } from "react";
import type { RefObject } from "react";

export default function useOutsideAlerter(
  ref: RefObject<HTMLElement> | RefObject<HTMLElement>[],
): boolean {
  const [clickedOutSide, setClickedOutSide] = useState(false);
  useEffect(() => {
    const refs = Array.isArray(ref) ? ref : [ref];
    function handleClickOutside(event: MouseEvent | PointerEvent) {
      const clickedInside = refs.some(
        r => r.current && r.current.contains(event.target as Node),
      );
      setClickedOutSide(!clickedInside);
    }

    // Use capture phase so handlers that stop propagation (e.g. Cesium canvas) do not block this listener.
    document.addEventListener("pointerdown", handleClickOutside, true);
    document.addEventListener("mousedown", handleClickOutside, true);

    return () => {
      setClickedOutSide(false);
      document.removeEventListener("pointerdown", handleClickOutside, true);
      document.removeEventListener("mousedown", handleClickOutside, true);
    };
  }, [ref]);
  return clickedOutSide;
}
